import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/zillehuma/zysoftec/source/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/node_modules/next/font/google/target.css?{\"path\":\"app/Components/Blog/BlogCard.jsx\",\"import\":\"Nunito_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\"]}],\"variableName\":\"nunito\"}");
